import React from 'react';

const StatBox = ({ icon, label, value, color }) => (
  <div style={{
    background: color,
    border: '4px solid rgba(0,0,0,0.2)',
    padding: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '6px 6px 0px rgba(0,0,0,0.2)',
    transition: 'all 0.2s ease'
  }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <div style={{ color: 'white' }}>{icon}</div>
      <span style={{ fontSize: '10px', color: 'white' }}>{label}</span>
    </div>
    <span style={{
      fontSize: '18px',
      color: 'white',
      fontWeight: 'bold'
    }}>
      {value.toLocaleString()}
    </span>
  </div>
);

export default StatBox;